// extracted by mini-css-extract-plugin
export default {"wrapper":"countSingleValue_wrapper__dE-Ys","inactive":"countSingleValue_inactive__vRXUO","label":"countSingleValue_label__+gPWD","count":"countSingleValue_count__Jg0nz"};